import { render, staticRenderFns } from "./commonTooltip.vue?vue&type=template&id=071dd9be&scoped=true"
import script from "./commonTooltip.vue?vue&type=script&lang=js"
export * from "./commonTooltip.vue?vue&type=script&lang=js"
import style0 from "./commonTooltip.vue?vue&type=style&index=0&id=071dd9be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071dd9be",
  null
  
)

export default component.exports